<template>
  <div class="settingPage">
    <div class="nav">
      <div class="caption">{{$t('lang.setting.setting')}}</div>
      <div class="navItem pointer" v-for="(item, index) in menuList" :key="index" @click="gotoRoute(item.href)">
        <img :src="fetchCurrentRoute(item.href)?item.srcAct:item.src" alt="">
        <div class="label" :class="{act: fetchCurrentRoute(item.href)}">{{item.label}}</div>
      </div>
      <div class="logout pointer" @click="logout">{{$t('lang.setting.logout')}}</div>
    </div>
    <div class="settingContainer">
      <router-view/>
    </div>
  </div>
</template>

<script>
import {mapMutations} from 'vuex'
const context = require.context('@/assets/images/Menu', true, /\.svg$/)
const imgList = {}
context.keys().forEach((key) => {
  imgList[key.replace('./', '').replace('.svg', '')] = context(key)
})
export default {
  name: 'Setting',
  data () {
    return {
      menuList: [
        {
          label: this.$t('lang.menu.Account'),
          src: imgList['account'],
          srcAct: imgList['accountAct'],
          href: 'Setting/Account'
        },
        {
          label: this.$t('lang.menu.Edit'),
          src: imgList['editInfo'],
          srcAct: imgList['editInfoAct'],
          href: 'Setting/Edit'
        },
        {
          label: this.$t('lang.menu.History'),
          src: imgList['history'],
          srcAct: imgList['historyAct'],
          href: 'Setting/History'
        },
        {
          label: this.$t('lang.menu.Message'),
          src: imgList['message'],
          srcAct: imgList['messageAct'],
          href: 'Setting/Message'
        }
      ]
    }
  },
  computed: {
    fetchCurrentRoute () {
      return (label) => {
        if (this.$store.state.currentRoute === 'Setting/Deposit' || this.$store.state.currentRoute === 'Setting/Withdraw') {
          return label === 'Setting/Account'
        }
        return label === this.$store.state.currentRoute
      }
    }
  },
  methods: {
    ...mapMutations({
      setCurrentRoute: 'setCurrentRoute'
    }),
    gotoRoute (href) {
      if (this.$store.state.currentRoute === href) return
      this.setCurrentRoute(href)
      this.$router.push('/' + href)
    },
    logout () {
      localStorage.removeItem('userInfo')
      if (this.$route.name === 'Home') {
        window.location.reload()
      } else {
        this.$router.go(0)
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (!localStorage.userInfo) {
        vm.$router.push('/')
      } else {
        vm.setCurrentRoute('Setting/' + vm.$route.name)
      }
    })
  }
}
</script>

<style lang="less" scoped>
  .settingPage {
    display: flex;
    padding: 10px 150px 100px 165px;
    .nav {
      position: relative;
      width: 180px;
      height: 588px;
      margin-right: 35px;
      background: #202020;
      border-radius: 6px 0 0 6px;
      text-align: center;
      .caption {
        margin: 38px 0;
        font-size: 24px;
        line-height: 28px;
        color: #F6D9AA;
        font-weight: bold;
      }
      .navItem {
        display: flex;
        align-items: center;
        margin-bottom: 30px;
        padding-left: 32px;
        img {
          width: 24px;
          margin-right: 18px;
        }
        .label {
          font-size: 18px;
          color: #686868;
        }
        .act {
          color: #F6D9AA;
        }
      }
      .logout {
        position: absolute;
        bottom: 20px;
        width: 100%;
        color: #F6D9AA;
      }
    }
    .settingContainer {
      position: relative;
      flex: 1;
      min-height: 588px;
      padding: 38px 120px;
      background: #202020;
      border-radius: 0 6px 6px 0;
      .title {
        font-size: 22px;
        line-height: 26px;
        color: #F6D9AA;
        font-weight: bold;
        margin-bottom: 30px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Setting/index.vue